import TreeModel from 'tree-model'
import { uniqueId } from 'lodash'

// DEPRECATED
export default function transformAttributes (dataSource, dataId) {
  const treeModel = new TreeModel()
  const node = treeModel.parse(dataSource)
  const attributes = []
  node.walk({strategy: 'post'}, node => {
    // all attributes have a type, if no type exists, it is a parent group
    const attr = node.model
    if (attr.type) {
      attr.dataset = dataId
      // add a string representation of the hierarchy
      attr.path = node.getPath().map(pathNode => {
        return pathNode.model !== node.model && !pathNode.isRoot() ? pathNode.model.name : undefined
      }).filter(n => n !== undefined).join(' / ')
      // immediate parent name for the target definition
      attr.parent = node.getPath().length > 2 ? node.parent.model.name : ''
      Object.freeze(attr)
      attributes.push(attr)
    }
    if (typeof attr.id === 'undefined') {
      attr.id = uniqueId(dataId)
    }
  })
  return {
    data: Object.freeze(dataSource),
    flat: Object.freeze({
      name: dataSource.name,
      attributes
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/components/common/attributes/index.js